import { render, staticRenderFns } from "./ProduccionAYB.vue?vue&type=template&id=8e699348"
import script from "./ProduccionAYB.vue?vue&type=script&lang=js"
export * from "./ProduccionAYB.vue?vue&type=script&lang=js"
import style1 from "./ProduccionAYB.vue?vue&type=style&index=1&id=8e699348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports